module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAbklEQVRIx2NgaLXHg/6+d8KDHksr40EMo0aPMKN/vgUhmhi945IjEFHT6D/vnb6+AaHk9Q5ABGH/oZbRXfsdWduhIkAGkPuHigEy+5gDRATIoHJYZ210jF7tAERABpWN3nfFEY0xmmVGjR68RgMA2fgdUtZT3o0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/sn.png
// module id = 929
// module chunks = 0